export const hu = {
    'nav.today': "Mai Áttekintés",
    'nav.calendar': "Keresleti Naptár",
    'nav.rates': "Árak és Szabályok",
    'nav.automation': "Automatizálás",
    'nav.audit': "Audit Napló",
    'nav.settings': "Beállítások",
    'sidebar.status': "Csatlakoztatva",
    'stat.occupancy': "Foglaltság",
    'stat.adr': "Átlagár (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Becs. Bevétel",
    'stat.trend.vsLastWeek': "vs Múlt Hét",
    'stat.trend.onPace': "Terv szerint",
    'dashboard.actions.title': "Javasolt Műveletek",
    'dashboard.actions.empty': "Nincs javaslat.",
    'filter.all': "Összes",
    'filter.pricing': "Árazás",
    'filter.restriction': "Korlátozások",
    'action.approve': "Jóváhagy",
    'action.reject': "Elutasít",
    'action.risk.low': "alacsony kockázat",
    'action.risk.medium': "közepes kockázat",
    'action.risk.high': "magas kockázat",
    'action.label.current': "Jelenlegi",
    'action.label.proposed': "Javasolt",
    'action.metric.impact': "Hatás",
    'action.metric.why': "Ok",
    'action.status.executed': "Auto-Végrehajtva",
    'header.search': "Keresés...",
    'header.logout': "Kijelentkezés",
    'auto.level.title': "Robotpilóta Szint",
    'auto.level.manual': "Manuális",
    'auto.level.manual.desc': "Minden javaslatot egyenként hagy jóvá.",
    'auto.level.assisted': "Támogatott",
    'auto.level.assisted.desc': "Alacsony kockázat auto-jóváhagyása. Nagyobbak ellenőrzése.",
    'auto.level.auto': "Teljesen Automata",
    'auto.level.auto.desc': "Az AI kezeli az árakat 24/7 a határokon belül.",
    'auto.level.active': "Aktív",
    'auto.guardrails.title': "Biztonsági Korlátok",
    'auto.guardrails.maxIncrease': "Max. Napi Emelés",
    'auto.guardrails.maxIncrease.desc': "Ársokk elkerülése.",
    'auto.guardrails.maxDecrease': "Max. Napi Csökkenés",
    'auto.guardrails.maxDecrease.desc': "Túl alacsony árak elkerülése.",
    'auto.guardrails.minRate': "Minimum Ár",
    'auto.guardrails.minRate.desc': "Soha ne adjon el ez alatt (Nettó).",
    'auto.emergency.title': "Vészhelyzeti Kontroll",
    'auto.emergency.label': "Vészleállítás",
    'auto.emergency.desc': "Automatizálás azonnali szüneteltetése.",
    'auto.emergency.btn': "RENDSZER SZÜNET",
    'rates.filter.all': "Összes Szobatípus",
    'rates.filter.next14': "Következő 14 Nap",
    'rates.export': "Exportálás",
    'audit.table.time': "Idő",
    'audit.table.actor': "Felhasználó",
    'audit.table.category': "Kategória",
    'audit.table.action': "Művelet",
    'audit.table.details': "Részletek",
    'audit.table.status': "Státusz",
    'settings.pms.title': "PMS Kapcsolat",
    'settings.pms.connected': "Kapcsolódva:",
    'settings.pms.disconnect': "Leválasztás",
    'settings.account.title': "Fiók",
    'settings.account.role': "Szerepkör",
    'settings.restart': "Onboarding Újraindítása",
    'onboard.title': "PMS Csatlakoztatása",
    'onboard.desc': "Válassza ki ingatlankezelő rendszerét (PMS).",
    'onboard.connecting': "Csatlakozás...",
    'onboard.connect': "Csatlakozás",
    'onboard.success.title': "Beállítás Kész!",
    'onboard.success.desc': "**SynthHotel Berlin** szinkronizálva.",
    'onboard.success.sub': "3 szobatípus, 14 árterv és 243 foglalás importálva.",
    'onboard.btn.dashboard': "Irány a Pult",
    'action.dynamic.weekend.title': "Hétvégi Áremelés",
    'action.dynamic.weekend.desc': "Fogl. > 75% Szombat, erős kereslet (+12 szoba 24ó alatt).",
    'action.dynamic.minstay.title': "Min. 2 Éjszaka Aktiválása",
    'action.dynamic.minstay.desc': "Taylor Swift koncert. 1 éjszakás foglalások tiltása.",
    'action.dynamic.distress.title': "Árcsökkentés (Gyenge Kereslet)",
    'action.dynamic.distress.desc': "Fogl. 35% jövő Kedd. Versenytársak 10€-t csökkentettek.",
    'action.dynamic.gap.title': "Lyukbetömés: CTA Törlése",
    'action.dynamic.gap.desc': "Egy éjszakás lyuk. 'Érkezés Tiltva' törlése az eladáshoz.",
};
